'use client';

import { useEffect } from 'react';

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error('[next_error_page] route-level error', {
      name: error.name,
      message: error.message,
      digest: error.digest ?? '',
      stack: error.stack,
    });
  }, [error]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-2xl rounded-xl border border-red-200 bg-white p-6 shadow-sm">
        <p className="text-base font-extrabold text-red-700">アプリケーションエラーが発生しました</p>
        <div className="mt-4 rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700">
          <p>
            <span className="font-bold">種別:</span> {error.name || 'Error'}
          </p>
          <p className="mt-1 break-all">
            <span className="font-bold">内容:</span> {error.message || 'Unknown error'}
          </p>
          {error.digest ? (
            <p className="mt-1">
              <span className="font-bold">Digest:</span> {error.digest}
            </p>
          ) : null}
        </div>
        <div className="mt-5 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={reset}
            className="rounded-md border border-slate-300 px-4 py-2 text-sm font-bold text-slate-700 hover:bg-slate-100"
          >
            再試行
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-md bg-slate-800 px-4 py-2 text-sm font-bold text-white hover:bg-slate-700"
          >
            再読み込み
          </button>
        </div>
      </div>
    </div>
  );
}
